var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import LogoWithMono from '../../../LogoWithMono';
const LogoTrenitaliaRe = (_a) => {
    var commonProps = __rest(_a, []);
    const source = {
        content: (React.createElement("svg", { width: 60, height: 18, viewBox: "0 0 60 18", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("path", { d: "M24.2452 0L24.3854 0.0367527C26.7749 0.663182 28.0526 2.39476 28.0526 4.95728C28.0526 8.18512 25.769 10.5438 22.7996 10.9498L26.1995 17.4007L26.5089 17.9786L24.5979 18H23.9716L20.288 11.0115H20.234L19.0987 17.9786H16.8213L17.954 11.0115L14 11.012V8.76043L18.3215 8.76L19.7454 0.0162016L19.7615 0.0180001L19.7618 0H24.2452ZM31.8142 0.0379894L33.8333 11.1685L39.7108 0.0379894H46.625V2.28952H41.0667L32.782 17.9786L29.9358 2.28952L29.5005 0.0379894H31.8142ZM23.9473 2.25153L21.6605 2.2515L20.6 8.76L21.8795 8.76043C24.0897 8.76043 25.8026 7.21355 25.8026 4.95728C25.8026 3.54425 25.3031 2.73598 24.1802 2.32787L23.9473 2.25153Z", fill: "black" }))),
        alt: 'Trenitalia Re',
    };
    return React.createElement(LogoWithMono, Object.assign({}, commonProps, { fixedHeight: 18, source: source }));
};
export default LogoTrenitaliaRe;
//# sourceMappingURL=index.js.map